import { get } from "../../../utils/objectHelpers";

$ {
    const icon = get(input, "icon", {});
    const text = get(input, "text", {});
    const href = get(input, "action.URL", null);
    const cssClasses = { class: `str-icon-text ${ get(input, "class", "") }` };
    const attrs = { href, ...cssClasses };
}

<span ...attrs>
    <str-icon ...icon />
    <str-textual-display ...text />
</span>
